import Draggable from '@/vendor/draggable/draggable';

export default Draggable;
